import { HttpInterceptorFn } from '@angular/common/http';
import { globalConfig } from '../utils/globalConfig';

/* export const httpInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  // Obtener el token del usuario
  const userToken = sessionStorage.getItem(globalConfig.tokenApi);
  console.log(req)
  // Clonar la petición y añadir las cabeceras
  const clonedReq = req.clone({
    url: `${globalConfig.apiUrl}${req.url}`,
    headers: req.headers.set('Authorization', `Bearer ${userToken}`),
  });
  console.log(clonedReq)
  // Pasar la petición clonada al siguiente manejador
  return next(clonedReq);
}; */
export const httpInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const url = `${globalConfig.apiUrl}${req.url}`;
  // ignoramos el interceptor para no clonar el encabezado
  if (req.headers.has('Skip-Interceptor')) {
    const clonedReq = req.clone({
      url: req.url,
      headers: req.headers.delete('Skip-Interceptor'), // Eliminar el encabezado para no pasarlo al backend
    });
    return next(clonedReq); // Ignora el interceptor para esta solicitud
  }

  const userToken = sessionStorage.getItem(globalConfig.tokenApi);
  // Clonar la petición y añadir las cabeceras
  const clonedReq = req.clone({
    url,
    headers: req.headers.set('Authorization', `Bearer ${userToken}`),
  });

  // Pasar la petición clonada al siguiente manejador
  return next(clonedReq);
};
